// General FAQ shown on the home page (with FAQPage structured data).
export const HOME_FAQ = [
  {
    q: "Qu'est-ce que Sapeur-360 ?",
    a: "Sapeur-360 est une plateforme robotisée sur chenilles qui se glisse sous un véhicule, le soulève de 13 à 45 cm (jusqu'à 3 000 kg), le déplace au centimètre près et peut projeter de l'eau pour éteindre les feux de véhicules, y compris électriques. C'est une innovation de Safetyrok SAS, sous la marque KRX.",
  },
  {
    q: "Quels types de véhicules peut-il soulever et déplacer ?",
    a: "La plateforme prend en charge la plupart des véhicules particuliers et utilitaires légers — thermiques comme électriques — jusqu'à 3 000 kg, grâce à un levage par le châssis, sans clé ni démarrage.",
  },
  {
    q: "Sapeur-360 peut-il éteindre les incendies de véhicules électriques ?",
    a: "Oui. Il projette de l'eau au plus près du foyer pour refroidir les batteries lithium, puis permet de déplacer le véhicule vers une zone sécurisée — une réponse adaptée aux réignitions propres aux véhicules électriques.",
  },
  {
    q: "À qui s'adresse Sapeur-360 ?",
    a: "Aux sapeurs-pompiers et services de secours, aux services de fourrière et dépanneurs, ainsi qu'aux garages, carrosseries, concessions et showrooms qui manipulent des véhicules au quotidien.",
  },
  {
    q: "Comment obtenir une démonstration ?",
    a: "Remplissez le formulaire de demande de démonstration sur cette page, ou appelez-nous au +33 (0)7 80 17 94 67. Nous organisons une démonstration sur votre site ou en visio, sans engagement.",
  },
];
